
<template>
  <div class="number">
    <div id="okdata" class="oknumber">
      <div id="oknumber_c">
        <div class="container">
          <!-- <div class="container_company"> -->
          <!--企业分类排序头部-->
          <!-- <h2>单位会员贡献</h2>
          <div class="container_company_1">
            <div class="company_ct">
              <el-radio-group v-model="cpmpany_radio1"  @change="inicpmpany_radio1">
                <el-radio-button label="month">一个月内</el-radio-button>
                <el-radio-button label="half">半年内</el-radio-button>
                <el-radio-button label="year">一年内</el-radio-button>
                <el-radio-button label="all">全部</el-radio-button>
              </el-radio-group>
            </div>
            <div class="demo-input-suffix">
              <el-input placeholder="请输入单位名称搜索" prefix-icon="el-icon-search" v-model="input_commany">   </el-input>
            </div>
          </div>
          <div style="margin-top: 20px">
            度量指标
            <el-radio-group v-model="cpmpany_radio2" size="medium" @change="inicpmpany_radio2">
              <el-radio-button label="pr">合并请求PR</el-radio-button>
              <el-radio-button label="issue">需求&问题Issue</el-radio-button>
             <el-radio-button label="commit">提交Commit</el-radio-button> -->
          <!-- </el-radio-group>
          </div>
          <div style="margin-top: 20px">
            显示范围
            <el-radio-group v-model="cpmpany_radio3" size="small" @change="inicpmpany_radio3">
              <el-radio-button label="10">TOP 10</el-radio-button>
              <el-radio-button label="20">TOP 20</el-radio-button>
              <el-radio-button label="all">全部</el-radio-button>
            </el-radio-group>
          </div> -->
          <!--企业贡献-->
          <!-- <el-table :data="tablecompanyData" style="width: 100%" > -->
          <!--<el-table-column prop="rank" label="排序" width="30">  </el-table-column>-->
          <!-- <el-table-column type="index" width="40">  </el-table-column>
            <el-table-column prop="name" label="名称" width="240">  </el-table-column>
          <el-table-column prop="count" label="贡献值">
              <template slot-scope="tablecompanyData">
                <el-progress :text-inside="true" typeof="line" :stroke-width="24" :percentage="setcompanyItemProgress(tablecompanyData.row.count)" :format="setcomItemText(tablecompanyData.row.count)"></el-progress>
              </template>
          </el-table-column>
          </el-table>
        </div> -->

          <div class="container_personal">
            <!--个人分类排序头部-->
            <h2>{{ $t('okmain.c_devel_contribute') }}</h2>
            <div class="personal_ct" style="height:34px;overflow: hidden;">
              <el-radio-group v-model="personal_radio1" @change="inipersonal_radio1" id="personal_ct">
                <el-radio-button label="month">{{ $t('okmain.c_time1') }}</el-radio-button>
                <el-radio-button label="half">{{ $t('okmain.c_time2') }}</el-radio-button>
                <el-radio-button label="year">{{ $t('okmain.c_time3') }}</el-radio-button>
                <el-radio-button label="all">{{ $t('okmain.c_all') }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="zhibiao">
              <span class="okrange">{{ $t('okmain.c_metrics') }}</span>
              <el-radio-group v-model="personal_radio2" size="medium" @change="inipersonal_radio2">
                <el-radio-button label="score">{{ $t('okmain.c_points') }}</el-radio-button>
                <el-radio-button label="pr">PR</el-radio-button>
                <el-radio-button label="issue">Issue</el-radio-button>
              </el-radio-group>
            </div>
            <div class="zhibiao">
              <span class="okrange">{{ $t('okmain.c_range') }}</span>
              <el-radio-group v-model="personal_radio3" size="small" @change="inipersonal_radio3">
                <el-radio-button label="10">TOP 10</el-radio-button>
                <el-radio-button label="20">TOP 20</el-radio-button>
                <el-radio-button label="all">{{ $t('okmain.c_all') }}</el-radio-button>
              </el-radio-group>
            </div>
            <!--个人贡献-->
            <el-table :data="tablepersonalData" style="width: 100%">
              <el-table-column type="index" :label="$t('okmain.c_sort')" min-width="5%"> </el-table-column>
              <!-- Gitee名显示 -->
              <el-table-column v-if="personal_radio2 == 'score'" prop="giteeId" :label="$t('okmain.c_giteename')"
                min-width="20%"> </el-table-column>
              <el-table-column v-else prop="name" :label="$t('okmain.c_giteename')" min-width="25%"> </el-table-column>
              <!-- 社区名显示 -->
              <el-table-column v-if="personal_radio2 == 'score'" prop="okUsername" :label="$t('okmain.c_communityname')"
                min-width="20%"> </el-table-column>
              <!-- 贡献值或积分值显示 -->
              <el-table-column v-if="personal_radio2 == 'score'" prop="value" :label="$t('okmain.c_pointvalue')"
                min-width="55%">
                <template slot-scope="tablepersonalData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablepersonalData.row.value)"
                    :format="setperItemText(tablepersonalData.row.value)"></el-progress>
                </template>
              </el-table-column>
              <el-table-column v-else prop="count" :label="$t('okmain.c_contributionvalue')" min-width="70%">
                <template slot-scope="tablepersonalData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablepersonalData.row.count)"
                    :format="setperItemText(tablepersonalData.row.count)"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入头部和尾部组件
import AppHeader from "./Header.vue"
import AppFooter from "./footer.vue"
export default {
  name: 'Number',
  data() {
    return {
      cpmpany_radio1: 'month',
      cpmpany_radio2: 'pr',
      cpmpany_radio3: 10,
      input_commany: '',
      personal_radio1: 'month',
      personal_radio2: 'pr',
      personal_radio3: 10,
      customColor: '#409eff',
      tablecompanyData: [],
      tablepersonalData: [],
      company_max: 0,
      pernal_max: 0
    }
  },
  // 引用头部和尾部组件
  components: {
    AppHeader,
    AppFooter
  },
  created() {
    if(this.personal_radio2 == "score")
      this.getpersonal_Score();
    else
      this.getpersonal_Data();
  },
  methods: {
    inicpmpany_radio1(value) {
      this.cpmpany_radio1 = value;
      this.getcompany_Data();
    },
    inicpmpany_radio2(value) {
      this.cpmpany_radio2 = value;
      this.getcompany_Data();

    },
    inicpmpany_radio3(value) {
      this.cpmpany_radio3 = value;
      this.getcompany_Data();
    },
    inipersonal_radio1(value) {
      this.personal_radio1 = value;
      this.getpersonal_Data();
    },
    inipersonal_radio2(value) {
      this.personal_radio2 = value;
      if (this.personal_radio2 == "score") {
        this.getpersonal_Score();
        // 把时间置灰personal_ct
        document.getElementById('personal_ct').style.display = 'none';
      }
      else {
        this.getpersonal_Data();
        // 把时间显示
        document.getElementById('personal_ct').style.display = 'block';

      }
    },
    inipersonal_radio3(value) {
      this.personal_radio3 = value;
      if (this.personal_radio2 == "score") {
        this.getpersonal_Score();
      }
      else {
        this.getpersonal_Data();

      }
    },
    setcomItemText(row) {
      return () => {
        return row;
      }
    },
    setperItemText(row) {
      return () => {
        return row;
      }
    },
    // 得到企业中贡献最大值
    setcompanyItemProgress(data) {
      if (data >= this.company_max) {
        return 80
      } else {
        return parseInt((data / this.company_max).toFixed(1) * 80) || 1
      }
    },
    // 得到个人中贡献最大值
    setpernalItemProgress(data) {
      if (data >= this.pernal_max) {
        return 90
      } else {
        return parseInt((data / this.pernal_max).toFixed(1) * 90) || 1
      }
    },
    // 企业的所有数据
    getcompany_Data: function () {
      this.axios({
        method: 'get',
        url: "https://dashboard-api.openkylin.top/api/data/member/" + this.cpmpany_radio2 + "?since=" + this.cpmpany_radio1 + "&top=" + this.cpmpany_radio3
      }).then(repos => {
        this.tablecompanyData = repos.data.data;
        this.company_max = this.tablecompanyData[0].count

      }).catch(function (error) {
        console.log(error);
      })
    },
    // 个人的所有数据
    getpersonal_Data: function () {
      this.axios({
        method: 'get',
        url: "https://dashboard-api.openkylin.top/api/data/developer/" + this.personal_radio2 + "?since=" + this.personal_radio1 + "&top=" + this.personal_radio3
      }).then(repos => {
        this.tablepersonalData = repos.data.data;
        this.pernal_max = this.tablepersonalData[0].count
      }).catch(function (error) {
        console.log(error);
      })
    },
    // 个人的所有积分
    getpersonal_Score: function () {
      this.axios({
        method: 'get',
        url: "https://dashboard-api.openkylin.top/api/data/member/score?top=" + this.personal_radio3
      }).then(repos => {
        this.tablepersonalData = repos.data.data;
        this.pernal_max = this.tablepersonalData[0].value
      }).catch(function (error) {
        console.log(error);
      })
    },
    //   getserch_Data: function () {
    //     this.axios({
    //       method: 'get',
    //       url: "https://dashboard-api.openkylin.top/api/data/overview?name=" + this.input_commany
    //     }).then(repos => {
    //       this.tablecompanyData = repos.data.data;

    //     }).catch(function (error) {
    //       console.log(error);
    //     })
    // },

  }

}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>




// WEBPACK FOOTER //
// src/components/Number.vue